<template>
    <el-dialog :visible.sync="visible" width="600px" title="上传凭证">
        <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="" prop="img">
                <Uploader v-model="form.img"></Uploader>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { consume } from "@/api/coupon/list";
import Uploader from "@/components/Uploader";
export default {
    components: { Uploader },
    data() {
        return {
            visible: false,
            form: {
                img: "",
            },
            rules: {
                img: [{ required: true, message: "请上传凭证" }],
            },
            uuid: "",
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            this.form.img = "";
            this.uuid = row.uuid;
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                consume({ uuid: this.uuid, img: this.form.img }).then(({ code, error }) => {
                    if (code === 200) {
                        this.$message.success("使用成功");
                        this.visible = false;
                        this.$emit("update");
                    } else {
                        this.$message.error(error.message);
                    }
                });
            });
        },
    },
};
</script>

<style></style>
